import React from 'react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
import { ArrowDown } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-[#FAF8F5] px-4 py-20" data-id="element-110">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-111">
        <div className="absolute -top-[10%] -right-[10%] w-[50%] h-[50%] rounded-full bg-[#8B9E8B]/10 blur-3xl" data-id="element-112" />
        <div className="absolute top-[20%] -left-[10%] w-[40%] h-[40%] rounded-full bg-[#C4836A]/10 blur-3xl" data-id="element-113" />
      </div>

      <div className="relative max-w-4xl mx-auto text-center z-10" data-id="element-114">
        <FadeIn delay={0.1} data-id="element-115">
          <span className="inline-block px-4 py-1.5 mb-6 text-sm font-medium tracking-wider text-[#5A6B5A] uppercase bg-[#8B9E8B]/10 rounded-full" data-id="element-116">
            Para mujeres que sostienen todo
          </span>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-117">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif text-[#3D3D3D] leading-tight mb-6" data-id="element-118">
            9 minutos para bajar <br data-id="element-119" />
            <span className="text-[#8B9E8B] italic" data-id="element-120">el ruido mental.</span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-121">
          <p className="text-lg md:text-xl text-[#5A6B5A] max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-122">
            Hay un tipo de ansiedad que nadie ve. La que no te tumba, pero te
            deja funcionar en alerta constante. Recupera tu calma sin tener que
            "ganártela".
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-123">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-124">
            <Button size="lg" onClick={scrollToPricing} data-id="element-125">
              Quiero recuperar mi paz
            </Button>
            <p className="text-sm text-[#8B9E8B] mt-4 sm:mt-0 sm:ml-4" data-id="element-126">
              Protocolo 3×3×3 • Solo 9 minutos
            </p>
          </div>
        </FadeIn>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1,
      y: [0, 10, 0]
    }} transition={{
      delay: 1,
      duration: 2,
      repeat: Infinity
    }} className="absolute bottom-10 left-1/2 transform -translate-x-1/2 text-[#8B9E8B]" data-id="element-127">
        <ArrowDown size={24} data-id="element-128" />
      </motion.div>
    </section>;
}
import { motion } from 'framer-motion';